import './bewerbende.css'

import CinematicShell from '../CinematicShell'
import { CANDIDATE_COPY } from './copy'
import CandApp from './scenes/CandApp'
import CandFair from './scenes/CandFair'
import CandFaq from './scenes/CandFaq'
import CandFlow from './scenes/CandFlow'
import CandHero from './scenes/CandHero'
import CandTips from './scenes/CandTips'

/**
 * Use Case „Bewerbenden-Infopage“: was Bewerbende nach der Einladung
 * erwartet, im Stil von Version 2. Die FAQ scrollt normal (flow).
 */
const SECTIONS = [
  { id: 'hero', height: 300, tone: 'light', Scene: CandHero },
  { id: 'ablauf', height: 680, tone: 'night', Scene: CandFlow },
  { id: 'fair', height: 480, tone: 'blue', Scene: CandFair },
  { id: 'tipps', height: 360, tone: 'light', Scene: CandTips },
  { id: 'faq', flow: true, tone: 'white', Scene: CandFaq },
  { id: 'app', height: 360, tone: 'night', Scene: CandApp }
]

export default function CandidateStory() {
  return <CinematicShell sections={SECTIONS} copy={CANDIDATE_COPY} />
}
